import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { createElement } from 'react'

import { AwsLambdaApiClient, awsLambdaApiRef } from './api'
import { isAwsLambdaAvailable } from './components/Router'
import { rootRouteRef } from './routes'

const awsLambdaApi = ApiBlueprint.make({
  name: 'aws-lambda',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: awsLambdaApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: options => new AwsLambdaApiClient(options),
      })
    ),
})

const entityAwsLambdaContent = EntityContentBlueprint.make({
  name: 'aws-lambda',
  params: {
    path: '/lambda',
    title: 'AWS Lambda',
    routeRef: rootRouteRef,
    filter: isAwsLambdaAvailable,
    loader: () => import('./components/Router.tsx').then(m => createElement(m.Router)),
  },
})

export const awsLambdaPlugin = createFrontendPlugin({
  pluginId: 'aws-lambda',
  routes: {
    root: rootRouteRef,
  },
  extensions: [awsLambdaApi, entityAwsLambdaContent],
})

export default awsLambdaPlugin
